export const getDefiningFileUnit = (fileSizeInBytes: number) => {
    let returnString = ''

    const fileSizeInKilobytes = Number((fileSizeInBytes / 1024).toFixed(1))
    const fileSizeInMegabytes = Number((fileSizeInKilobytes / 1024).toFixed(1))
    const fileSizeInGigabytes = Number((fileSizeInMegabytes / 1024).toFixed(1))

    if (fileSizeInBytes < 1024) {
        returnString = `${fileSizeInBytes} B`
    } else if (fileSizeInKilobytes < 1024) {
        returnString = `${fileSizeInKilobytes} KB`
    } else if (fileSizeInMegabytes < 1024) {
        returnString = `${fileSizeInMegabytes} MB`
    } else {
        returnString = `${fileSizeInGigabytes} GB`
    }

    return returnString
}

/** Функция принимает число и возвращает строку, содержащую число и правильное склонение слова "час" */
export const formatHours = (number: number) => {
    const remainder10 = number % 10
    const remainder100 = number % 100

    if (remainder100 >= 11 && remainder100 <= 20) {
        return number + ' часов'
    } else if (remainder10 === 1) {
        return number + ' час'
    } else if (remainder10 >= 2 && remainder10 <= 4) {
        return number + ' часа'
    } else {
        return number + ' часов'
    }
}
